<script lang="ts">
  import Separator from './Separator.svelte'

  interface Props {
    separator?: boolean
    spacing?: 'none' | 'first' | 'content'
    centered?: boolean | 'block' | 'inline'
    width?: 'full' | 'medium' | 'narrow'
    height?: 'auto' | 'full'
    color?: 'green' | 'blue' | 'yellow' | 'red' | 'grey' | 'purple' | 'black'
    children?: import('svelte').Snippet
  }

  let {
    separator = false,
    spacing = 'none',
    centered = false,
    width = 'full',
    height = 'auto',
    color = 'grey',
    children,
  }: Props = $props()
</script>

<section
  class="{color} spacing-{spacing} width-{width} height-{height}"
  class:centered-inline={centered === 'inline'}
  class:centered-block={centered === 'block'}
  class:centered={centered === true}
>
  {#if separator}
    <Separator top />
  {/if}
  {@render children?.()}
</section>

<style lang="postcss">
  section {
    --section-color: 'unset';
    --_edge-margin: 0;
    position: relative;
    margin-inline: var(--_edge-margin);
    padding-inline: var(--size-content-px);
    &.spacing-first {
      padding-block: fluid(1.5rem, 3rem, 480px, 1128px) var(--size-section-py);
    }
    &.spacing-content {
      padding-block: var(--size-section-py);
    }

    &.centered {
      display: grid;
      place-content: center;
    }
    &.centered-inline {
      display: grid;
      justify-content: center;
    }
    &.centered-block {
      display: grid;
      align-content: center;
    }

    &.width-medium {
      padding-inline: var(--size-content-medium-px);
    }
    &.width-narrow {
      padding-inline: var(--size-content-narrow-px);
    }

    &.height-full {
      min-height: calc(100vh);
      &.spacing-first {
        padding-block: fluid(1.5rem, 3rem, 480px, 1128px);
        min-height: calc(100vh - var(--size-header-height));
      }
    }

    &.black {
      --section-color: var(--color-bg-accent);
      --separator-color: var(--color-bg-accent);
      /* --_edge-margin: 1rem;
      border-radius: var(--radius-3xl); */
      background-color: var(--color-bg-dark);
      color: var(--color-text-ondark);
      & :global(strong) {
        color: var(--color-text-accent-ondark);
      }
    }

    &.green,
    &.blue,
    &.yellow,
    &.red,
    &.purple {
      --section-color: var(--color-text-brand);
      --separator-color: var(--color-text);
    }
    &.grey {
      --section-color: var(--color-text-tertiary);
      --separator-color: var(--color-text);
    }
  }
</style>
